import { Project } from '@work4all/models/lib/Classes/Project.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { ProjectPicker } from '../../../../../entity-picker/project-picker/ProjectPicker';
import { withExtras } from '../../utils';

import { PreviewPickerInput } from './PreviewPickerInput';

export const ProjectPreviewPickerInput = withExtras<Project>(
  ({
    value,
    onChange,
    prefilter,
    searchPrefilter,
    sortBy,
    sortByDirection,
    useSearchHistory,
    ...rest
  }) => {
    return (
      <PreviewPickerInput<Project>
        {...rest}
        value={value}
        formattedValue={value?.name}
        picker={
          <ProjectPicker
            value={value}
            onChange={onChange}
            multiple={false}
            favorites={true}
            prefilter={prefilter}
            searchPrefilter={searchPrefilter}
            sortBy={sortBy}
            sortByDirection={sortByDirection}
            useSearchHistory={useSearchHistory}
          />
        }
        onChange={onChange}
        entity={Entities.project}
      />
    );
  }
);
